import { OrderingInitialState, SelectToppingAction } from '@reducers/ordering/types';
import { current } from '@reduxjs/toolkit';

export const selectTopping = (state: OrderingInitialState, action: SelectToppingAction): OrderingInitialState => {
  const selected = action.payload;
  if (selected.topping.length === 0) return state;

  const find = current(state.orderState.selectedTopping).find(
    (x) => x.toppingCategoryId === selected.toppingCategoryId
  );
  if (find) {
    return {
      ...state,
      orderState: {
        ...state.orderState,
        selectedTopping: state.orderState.selectedTopping.map((item) => {
          if (item.toppingCategoryId === selected.toppingCategoryId) {
            return {
              ...item,
              topping: selected.topping,
            };
          }
          return item;
        }),
      },
    };
  }

  return {
    ...state,
    orderState: {
      ...state.orderState,
      selectedTopping: [...state.orderState.selectedTopping, selected],
    },
  };
};
